import { markerclusterer } from "vendor";
class Map {
  constructor(elem) {
    this.elem = elem;
    this.holder = this.elem.find(".map-holder");

    this.markers = [];
    this.markerCluster;
    this.markerClusterOptions = {
      averageCenter: true,
      cssClass: "cluster-Marker",
    };
    this.latitude = 0;
    this.longitude = 0;
    this.zoom = 12;
    this.gmap = null;
    this.searchCircle;
    this.searchMarker;
    this.searchField = document.getElementById("ballast-map-search");

    this.searchField?.addEventListener("input", event => {
      document.querySelector(".ballast-map__no-hits-text").classList.remove("show-error-msg");
    });

    if (
      window.hasOwnProperty("google") &&
      window.google.hasOwnProperty("maps")
    ) {
      this.createMap();
    } else {
      window.addEventListener(
        "google-maps-loaded",
        (e) => {
          this.createMap();
        },
        false
      );
    }
  }

  loadPosition() {
    let data = this.holder.data("position");
    data = data.split(",");

    this.latitude = parseFloat(data[0]);
    if (isNaN(this.latitude)) {
      this.latitude = 60.1299555;
    }

    this.longitude = parseFloat(data[1]);
    if (isNaN(this.longitude)) {
      this.longitude = 17.2169883;
    }

    this.position = { lat: this.latitude, lng: this.longitude };

    if (data.length > 2) {
      this.zoom = parseFloat(data[2]);
    } else {
      this.zoom = 5.61;
    }
  }

  loadMarkerSource() {
    var _self = this;
    var source = this.holder.data("marker-source");
    var dataArray;

    if (source.indexOf("http") !== -1 || source[0] === "/") {
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          dataArray = JSON.parse(xmlhttp.responseText);
          dataArray.forEach(function (data) {
            _self.createMarker(data);
          });

          _self.markerCluster = new MarkerClusterer(
            _self.gmap,
            _self.markers,
            _self.markerClusterOptions
          );
        }
      };
      xmlhttp.open("GET", this.holder.data("marker-source"), true);
      xmlhttp.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      xmlhttp.send();
    } else {
      dataArray = source;
      window.addEventListener("load", function () {
        dataArray.forEach(function (data) {
          _self.createMarker(data);
        });

        _self.markerCluster = new MarkerClusterer(
          _self.gmap,
          _self.markers,
          _self.markerClusterOptions
        );
      });
    }
  }

  createMarkerIcon(pinColor = "#18173c") {
    var pinSVGHole =
      "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";
    var labelOriginFilled = new google.maps.Point(12, 9);

    // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
    return {
      path: pinSVGHole,
      anchor: new google.maps.Point(12, 17),
      fillOpacity: 1,
      fillColor: pinColor,
      strokeWeight: 2,
      strokeColor: "#ffffff",
      scale: 2,
      labelOrigin: labelOriginFilled,
    };
  }

  createMarker(data) {
    var marker = new google.maps.Marker({
      position: data,
      title: this.holder.data("title"),
      icon: this.createMarkerIcon("#0606cc"),
    });
    if (data.content)
      marker.infowindow = new google.maps.InfoWindow({
        content: data.content,
      });
    marker.addListener("click", () => this.onMarkerClicked(marker));

    this.markers.push(marker);
  }

  geocodeAddress(geocoder, distance) {
    var _self = this;
    var countryCode = _self.holder.data("postal-country-code");
    var searchField = $("#ballast-map-search");
    var address = searchField.val();

    geocoder.geocode(
      { address, componentRestrictions: { country: countryCode } },
      function (results, status) {
        if (status === "OK") {
          if (results[0].address_components.length > 1) {
            _self.updateMap(results[0].geometry.location, distance);
          } else {
            document.querySelector(".ballast-map__no-hits-text").classList.add("show-error-msg");
          }
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status
          );
        }
      }
    );
  }

  updateMap(center, selectedDistance) {
    var circleOptions = {
      center: center,
      fillOpacity: 0,
      strokeOpacity: 0,
      map: this.gmap,
      radius: selectedDistance * 1000000,
    };
    var reducedMarkers = this.reduceMarkers(center, circleOptions.radius);
    var _self = this;

    // Clear previous circle/red marker
    if (typeof this.searchCircle !== "undefined") {
      this.searchCircle.setMap(null);
      this.searchMarker.setMap(null);
    }

    // Clear previous markerCluster (the blue markers)
    this.markerCluster.clearMarkers();

    this.gmap.setCenter(center);
    this.gmap.setZoom(this.getZoom(selectedDistance));

    this.searchMarker = new google.maps.Marker({
      map: this.gmap,
      position: center,
      icon: this.createMarkerIcon(),
      animation: google.maps.Animation.DROP,
    });
    this.searchCircle = new google.maps.Circle(circleOptions);

    // Make sure new clusters is rendered after zoom animation
    setTimeout(function () {
      _self.markerCluster = new MarkerClusterer(
        _self.gmap,
        reducedMarkers,
        _self.markerClusterOptions
      );
    }, 800);
  }

  reduceMarkers(searchLocation, searchDistance) {
    return this.markers.filter(function (m) {
      var markerLocation = new google.maps.LatLng(
        m.position.lat(),
        m.position.lng()
      );
      var distanceBetween =
        google.maps.geometry.spherical.computeDistanceBetween(
          markerLocation,
          searchLocation
        );

      return distanceBetween <= searchDistance;
    });
  }

  currentPosition(map, distance) {
    var _self = this;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          var pos = new google.maps.LatLng(
            position.coords.latitude,
            position.coords.longitude
          );

          _self.updateMap(pos, distance);
        },
        function (error) {
          // Browser has Geolocation.
          console.error("The Geolocation service failed. Error:", error);
        }
      );
    } else {
      // Browser doesn't support Geolocation
      console.error("Your browser doesn't support geolocation.");
    }
  }

  createMap() {
    if (this.holder.data("position")) {
      this.loadPosition();
    }

    this.gmap = new google.maps.Map(this.holder[0], {
      center: this.position,
      scrollwheel: false,
      zoom: this.zoom,
    });

    if (this.holder.data("marker-source")) {
      this.loadMarkerSource();
    } else {
      this.createMarker(this.position);
    }

    $(window).on("refresh-map", () => this.refreshMap());

    const submitButton = document.getElementById("map-submit");
    const ballastMapSearch = document.getElementById("ballast-map-search");
    const mapGeolocation = document.getElementById("map-geolocation");

    if (submitButton) {
      submitButton.addEventListener("click", (event) => {
        this.searchCity(event);
      });
    }

    if (ballastMapSearch) {
      // Enter-key keypress
      ballastMapSearch.addEventListener("keyup", (event) => {
        if (event.keyCode === 13) {
          this.searchCity(event);
        }
      });
    }

    if (mapGeolocation) {
      mapGeolocation.addEventListener("click", (event) => {
        var distance = $(".selected-distance").text().split(" ").shift();
        this.currentPosition(this.gmap, distance);
      });
    }
  }

  searchCity(event) {
    // old way of getting distance
    var distance = $(".selected-distance").text().split(" ").shift();

    if (!distance) {
      // if no result, try new way of getting distance
      try {
        distance = $(".combobox--select > select").val();
      } catch (e) {
        console.error("Missing distance field.");
        console.log("error: ", e);
      }
    }
    var geocoder = new google.maps.Geocoder();

    event.preventDefault();
    this.geocodeAddress(geocoder, distance);
  }

  refreshMap() {
    console.log("refreshmap " + this.gmap);
    google.maps.event.trigger(this.gmap, "resize");
    this.gmap.setZoom(this.gmap.getZoom());
    this.gmap.setCenter(this.position);
  }

  onMarkerClicked(marker) {
    if (marker.infowindow) {
      marker.infowindow.open(this.gmap, marker);
    }
  }

  getZoom(distance) {
    switch (distance) {
      case "10":
        return 11.4;

      case "50":
        return 9;

      case "100":
        return 8;

      case "200":
        return 7;

      default:
        return 9;
    }
  }
}

export default Map;
